module.exports = __webpack_public_path__ + "static/media/shape1_1.f068fa48.obj";